// Ładowanie oznacza NASZ ZNAK, nie kółko z biblioteki.
//
// Stało tu wcześniej gotowe SVG z kręcącym się okręgiem — ten sam, który
// widać w tysiącu innych aplikacji. Chwila ładowania to jedyny moment, gdy
// ekran nie ma nic do powiedzenia poza „jesteśmy", więc mówi to znakiem.
//
// Znak ODDYCHA, nie kręci się: obrót udaje postęp, którego nie mierzymy —
// nie wiemy, ile zostało do końca ładowania fragmentu kodu. Pulsowanie
// mówi „pracujemy" i niczego nie obiecuje.

// styling
import styles from './style.module.scss';

// assets
import znak from '@assets/logo.svg';

/**
 * @param {boolean} visible  zgodność z dotychczasowym wywołaniem
 * @param {boolean} pelnyEkran  wysokość całego okna — dla ładowania CAŁEJ
 *        aplikacji. Domyślnie NIE, bo ten sam komponent jest zapasem dla
 *        fragmentów wewnątrz gotowego ekranu i wewnątrz okna wyboru planu,
 *        gdzie 100vh rozpychało treść na cały ekran.
 */
const Loader = ({ visible = true, pelnyEkran = false }) => {
    if (!visible) return null;

    return (
        <div className={pelnyEkran ? `${styles.kontener} ${styles.pelny}` : styles.kontener}
             role="status"
             aria-live="polite">
            <img className={styles.znak} src={znak} alt="" width="48" height="48"/>
            {/* Dla czytnika ekranu: obrazek jest ozdobą (alt=""), więc stan
                musi powiedzieć tekst. Na ekranie go nie ma — tam mówi znak. */}
            <span className={styles.dlaCzytnika}>Ładowanie</span>
        </div>
    );
};

export default Loader;
